import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  locationInfoLoader: false,
  locationInfoReduxDetails: null,
  selectedBusinessName: null,
  businessNamesData: [],
  mapRankSection: 0,
  selectedLocationId: null,
  localPostNameId: null,
  updatePostLoader: null,
  gmpListData: [],
  locationInfoProfileImageObj: null,
  locationInfoCoverImageObj: null,
  selectedBusinessNameFilter: null,
  selectedTimelineFilter: null,
  selectedAccountId: null,
  selectedLocalSeoTask: '',
  reduxLocationsData: null,
  locationsDetailsLoader: null,
  googleListingTitle: null,
  selectedBusinessAccountId: null,
  reduxFilteredLocationsData: [],
  getReportDetails: null,
  selectedMapKeyword: null,
  createMapData: null,
  selectedPlaceId: null,
  createMapRankDetails: null,
  showLocalMap: null,
  newMapRankKeywords: null,
  locationListErrorRedux: null,
  businessNameInputValue: null,
  businessNameSelectedValue: null,
  isLocationDataUpdated: null,
  isProfileDeleted: null,
  isLocalSeoUnlocked: null,
  locationListResponse: null,
  isConnectionFlow: null,
  tempLocationId: null,
  tempAccountId: null,
  selectedBusinessRow: null,
  additionalImages: null,
  isEditKeywords: null,
  isProfileDeletedUpdate: null,
  isProfileDeletedLocation: null,
  localPostStatus: null,
  selectedGridValue: '0.3 mi',
  keywordsArray: null,
  selectedTimeLine: 'Every Month',
  locationInfoData: null,
  manageReviewsSection: 0,
  reviewList: null,
  locationFieldModalLoading: true,
  isNoLocationAddressFieldEntered: false,
  isLocationInfoDetails: null,
  autoSelectedCategoryId: null,
  selectedAddressPlaceId: null,
  widgetDetails: [],
  previewCustomCss: null,
  editWidgetLoading: null,
  isEditWidgetId: null,
  isSelectedProfileDeleted: null,
  isCallLocations: null,
  isAlreadyConnectedBusiness: null,
  isSqSpExtDisconnected: null,
  isAlreadyConnectedBusinessData: null,
  isUpgradedToSeo: null,
  isLocalSeoExtResultAccessed: null,
  mapScreenshots: {} as Record<string, string>,
  mapScreenshotSignal: 'idle' as 'idle' | 'capturing' | 'done',
  pdfBuilderSelectedLocationId: []
};

/**
 * Redux slice for managing counter-related state.
 *
 * @name siteAuditSlice
 * @type {Slice}
 */
// Action functions declaration
export const localSeoSlice = createSlice({
  name: 'localSeo',
  initialState,
  reducers: {
    setLocationInfoLoader: (state, action) => {
      // Add a new reducer to set itemId
      state.locationInfoLoader = action.payload;
    },
    setLocationInfoReduxDetails: (state, action) => {
      // Add a new reducer to set itemId
      state.locationInfoReduxDetails = action.payload;
    },
    setSelectedBusinessName: (state, action) => {
      // Add a new reducer to set itemId
      state.selectedBusinessName = action.payload;
    },
    setBusinessNamesData: (state, action) => {
      // Add a new reducer to set itemId
      state.businessNamesData = action.payload;
    },
    setMapRankSection: (state, action) => {
      // Add a new reducer to set itemId
      state.mapRankSection = action.payload;
    },
    setSelectedLocationId: (state, action) => {
      // Add a new reducer to set itemId
      state.selectedLocationId = action.payload;
    },
    setLocalPostNameId: (state, action) => {
      // Add a new reducer to set itemId
      state.localPostNameId = action.payload;
    },
    setUpdatePostLoader: (state, action) => {
      // Add a new reducer to set itemId
      state.updatePostLoader = action.payload;
    },
    setGmpListData: (state, action) => {
      // Add a new reducer to set itemId
      state.gmpListData = action.payload;
    },
    setLocationInfoProfileImageObj: (state, action) => {
      // Add a new reducer to set itemId
      state.locationInfoProfileImageObj = action.payload;
    },
    setLocationInfoCoverImageObj: (state, action) => {
      // Add a new reducer to set itemId
      state.locationInfoCoverImageObj = action.payload;
    },
    setSelectedBusinessNameFilter: (state, action) => {
      // Add a new reducer to set itemId
      state.selectedBusinessNameFilter = action.payload;
    },
    setSelectedTimelineFilter: (state, action) => {
      // Add a new reducer to set itemId
      state.selectedTimelineFilter = action.payload;
    },
    setSelectedAccountId: (state, action) => {
      // Add a new reducer to set itemId
      state.selectedAccountId = action.payload;
    },
    setSelectedLocalSeoTask: (state, action) => {
      // Add a new reducer to set itemId
      state.selectedLocalSeoTask = action.payload;
    },
    setReduxLocationsData: (state, action) => {
      // Add a new reducer to set itemId
      state.reduxLocationsData = action.payload;
    },
    setLocationsDetailsLoader: (state, action) => {
      // Add a new reducer to set itemId
      state.locationsDetailsLoader = action.payload;
    },
    setGoogleListingTitle: (state, action) => {
      // Add a new reducer to set itemId
      state.googleListingTitle = action.payload;
    },
    setSelectedBusinessAccountId: (state, action) => {
      // Add a new reducer to set itemId
      state.selectedBusinessAccountId = action.payload;
    },
    setReduxFilteredLocationsData: (state, action) => {
      // Add a new reducer to set itemId
      state.reduxFilteredLocationsData = action.payload;
    },
    setGetReportDetails: (state, action) => {
      // Add a new reducer to set itemId
      state.getReportDetails = action.payload;
    },
    setSelectedMapKeyword: (state, action) => {
      // Add a new reducer to set itemId
      state.selectedMapKeyword = action.payload;
    },
    setCreateMapData: (state, action) => {
      // Add a new reducer to set itemId
      state.createMapData = action.payload;
    },
    setSelectedPlaceId: (state, action) => {
      // Add a new reducer to set itemId
      state.selectedPlaceId = action.payload;
    },
    setCreateMapRankDetails: (state, action) => {
      // Add a new reducer to set itemId
      state.createMapRankDetails = action.payload;
    },
    setShowLocalMap: (state, action) => {
      // Add a new reducer to set itemId
      state.showLocalMap = action.payload;
    },
    setNewMapRankKeywords: (state, action) => {
      // Add a new reducer to set itemId
      state.newMapRankKeywords = action.payload;
    },
    setLocationListErrorRedux: (state, action) => {
      // Add a new reducer to set itemId
      state.locationListErrorRedux = action.payload;
    },
    setBusinessNameInputValue: (state, action) => {
      // Add a new reducer to set itemId
      state.businessNameInputValue = action.payload;
    },
    setBusinessNameSelectedValue: (state, action) => {
      // Add a new reducer to set itemId
      state.businessNameSelectedValue = action.payload;
    },
    setLocationDataUpdated: (state, action) => {
      // Add a new reducer to set itemId
      state.isLocationDataUpdated = action.payload;
    },
    setIsProfileDeleted: (state, action) => {
      // Add a new reducer to set itemId
      state.isProfileDeleted = action.payload;
    },
    setIsLocalSeoUnlocked: (state, action) => {
      // Add a new reducer to set itemId
      state.isLocalSeoUnlocked = action.payload;
    },
    setLocationListResponse: (state, action) => {
      // Add a new reducer to set itemId
      state.locationListResponse = action.payload;
    },
    setIsConnectionFlow: (state, action) => {
      // Add a new reducer to set itemId
      state.isConnectionFlow = action.payload;
    },
    setTempLocationId: (state, action) => {
      // Add a new reducer to set itemId
      state.tempLocationId = action.payload;
    },
    setTempAccountId: (state, action) => {
      // Add a new reducer to set itemId
      state.tempAccountId = action.payload;
    },
    setSelectedBusinessRow: (state, action) => {
      // Add a new reducer to set itemId
      state.selectedBusinessRow = action.payload;
    },
    setAdditionalImages: (state, action) => {
      // Add a new reducer to set itemId
      state.additionalImages = action.payload;
    },
    setIsEditKeywords: (state, action) => {
      // Add a new reducer to set itemId
      state.isEditKeywords = action.payload;
    },
    setIsProfileDeletedUpdate: (state, action) => {
      // Add a new reducer to set itemId
      state.isProfileDeletedUpdate = action.payload;
    },
    setIsProfileDeletedLocation: (state, action) => {
      // Add a new reducer to set itemId
      state.isProfileDeletedLocation = action.payload;
    },
    setLocalPostStatus: (state, action) => {
      // Add a new reducer to set itemId
      state.localPostStatus = action.payload;
    },
    setSelectedGridValue: (state, action) => {
      // Add a new reducer to set itemId
      state.selectedGridValue = action.payload;
    },
    setKeywordsArray: (state, action) => {
      // Add a new reducer to set itemId
      state.keywordsArray = action.payload;
    },
    setSelectedTimeLine: (state, action) => {
      // Add a new reducer to set itemId
      state.selectedTimeLine = action.payload;
    },
    setLocationInfoData: (state, action) => {
      // Add a new reducer to set itemId
      state.locationInfoData = action.payload;
    },
    setManageReviewsSection: (state, action) => {
      // Add a new reducer to set itemId
      state.manageReviewsSection = action.payload;
    },
    setReviewList: (state, action) => {
      // Add a new reducer to set itemId
      state.reviewList = action.payload;
    },
    setLocationFieldModalLoading: (state, action) => {
      // Add a new reducer to set itemId
      state.locationFieldModalLoading = action.payload;
    },
    setIsNoLocationAddressFieldEntered: (state, action) => {
      // Add a new reducer to set itemId
      state.isNoLocationAddressFieldEntered = action.payload;
    },
    setIsLocationInfoDetails: (state, action) => {
      // Add a new reducer to set itemId
      state.isLocationInfoDetails = action.payload;
    },
    setAutoSelectedCategoryId: (state, action) => {
      // Add a new reducer to set itemId
      state.autoSelectedCategoryId = action.payload;
    },
    setSelectedAddressPlaceId: (state, action) => {
      // Add a new reducer to set itemId
      state.selectedAddressPlaceId = action.payload;
    },
    setWidgetDetails: (state, action) => {
      // Add a new reducer to set itemId
      state.widgetDetails = action.payload;
    },
    setPreviewCustomCss: (state, action) => {
      // Add a new reducer to set itemId
      state.previewCustomCss = action.payload;
    },
    setEditWidgetLoading: (state, action) => {
      // Add a new reducer to set itemId
      state.editWidgetLoading = action.payload;
    },
    setIsEditWidgetId: (state, action) => {
      // Add a new reducer to set itemId
      state.isEditWidgetId = action.payload;
    },
    setIsSelectedProfileDeleted: (state, action) => {
      // Add a new reducer to set itemId
      state.isSelectedProfileDeleted = action.payload;
    },
    setIsCallLocations: (state, action) => {
      // Add a new reducer to set itemId
      state.isCallLocations = action.payload;
    },
    setIsAlreadyConnectedBusiness: (state, action) => {
      // Add a new reducer to set itemId
      state.isAlreadyConnectedBusiness = action.payload;
    },
    setIsSqSpExtDisconnected: (state, action) => {
      // Add a new reducer to set itemId
      state.isSqSpExtDisconnected = action.payload;
    },
    setIsAlreadyConnectedBusinessData: (state, action) => {
      // Add a new reducer to set itemId
      state.isAlreadyConnectedBusinessData = action.payload;
    },
    setIsUpgradedToSeo: (state, action) => {
      // Add a new reducer to set itemId
      state.isUpgradedToSeo = action.payload;
    },
    setIsLocalSeoExtResultAccessed: (state, action) => {
      // Add a new reducer to set itemId
      state.isLocalSeoExtResultAccessed = action.payload;
    },
    setMapScreenshots: (state, action) => {
      state.mapScreenshots = action.payload;
    },
    updateMapScreenshot: (
      state,
      action: { payload: { keyword: string; base64: string } }
    ) => {
      state.mapScreenshots[action.payload.keyword] = action.payload.base64;
    },
    setMapScreenshotSignal: (state, action) => {
      state.mapScreenshotSignal = action.payload;
    },
    setPdfBuilderSelectedLocationId: (state, action) => {
      state.pdfBuilderSelectedLocationId = action.payload;
    },

    /**
     * Clean up and reset the state to its initial values.
     *
     * @function
     * @name cleanupInitialState
     */
    cleanupLocalSeoInitialState: () => initialState
  }
});

export const {
  setLocationInfoLoader,
  setLocationInfoReduxDetails,
  setSelectedBusinessName,
  setBusinessNamesData,
  setMapRankSection,
  setSelectedLocationId,
  setLocalPostNameId,
  setUpdatePostLoader,
  setGmpListData,
  setLocationInfoProfileImageObj,
  setLocationInfoCoverImageObj,
  setSelectedBusinessNameFilter,
  setSelectedTimelineFilter,
  setSelectedAccountId,
  setSelectedLocalSeoTask,
  setReduxLocationsData,
  setLocationsDetailsLoader,
  setGoogleListingTitle,
  setSelectedBusinessAccountId,
  setReduxFilteredLocationsData,
  setGetReportDetails,
  setSelectedMapKeyword,
  setCreateMapData,
  cleanupLocalSeoInitialState,
  setSelectedPlaceId,
  setCreateMapRankDetails,
  setShowLocalMap,
  setNewMapRankKeywords,
  setLocationListErrorRedux,
  setBusinessNameInputValue,
  setBusinessNameSelectedValue,
  setLocationDataUpdated,
  setIsProfileDeleted,
  setIsLocalSeoUnlocked,
  setLocationListResponse,
  setIsConnectionFlow,
  setTempLocationId,
  setTempAccountId,
  setSelectedBusinessRow,
  setAdditionalImages,
  setIsEditKeywords,
  setIsProfileDeletedUpdate,
  setIsProfileDeletedLocation,
  setLocalPostStatus,
  setSelectedGridValue,
  setKeywordsArray,
  setSelectedTimeLine,
  setLocationInfoData,
  setManageReviewsSection,
  setReviewList,
  setLocationFieldModalLoading,
  setIsNoLocationAddressFieldEntered,
  setIsLocationInfoDetails,
  setAutoSelectedCategoryId,
  setSelectedAddressPlaceId,
  setWidgetDetails,
  setPreviewCustomCss,
  setEditWidgetLoading,
  setIsEditWidgetId,
  setIsSelectedProfileDeleted,
  setIsCallLocations,
  setIsAlreadyConnectedBusiness,
  setIsSqSpExtDisconnected,
  setIsAlreadyConnectedBusinessData,
  setIsUpgradedToSeo,
  setIsLocalSeoExtResultAccessed,
  setMapScreenshots,
  updateMapScreenshot,
  setMapScreenshotSignal,
  setPdfBuilderSelectedLocationId
} = localSeoSlice.actions;

export default localSeoSlice.reducer;
